import { AssetTypesImageVideo, FieldType, FilterFormDataModel, PROMPTS, WidthClass } from '@thehubz/client/core';
import { CustomClients } from '@thehubz/shared/branding';
import { getBrandModelListSEAT, getDriveListSEAT, getSpecialModelListSEAT, getTrimListSEAT } from '../customer-metadata-config';
import { BRANDMARKE, CHANNELS, MEDIATYPE } from './seat-form-fields';

export const seatFilterFormData: FilterFormDataModel = {
  title: 'Asset',
  description: '',
  customClient: CustomClients.SEAT,
  formFields: [
    {
      formTypeId: '9',
      formFieldName: 'brandMarke',
      fieldType: FieldType.Dropdown,
      fieldLabel: 'Marke',
      placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
      inputType: '',
      mandatory: false,
      validationRegex: '',
      widthClass: WidthClass.W12,
      subProjectFlag: false,
      disable: false,
      formGroup: true,
      visible: true,
      options: BRANDMARKE,
    },
    {
      formTypeId: '10',
      formFieldName: 'brandModel',
      fieldType: FieldType.Dropdown,
      fieldLabel: 'Model',
      placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
      inputType: '',
      mandatory: false,
      validationRegex: '',
      widthClass: WidthClass.W12,
      disable: false,
      formGroup: true,
      visible: true,
      options: getBrandModelListSEAT(),
    },
    {
      formTypeId: '1',
      formFieldName: 'specialModel',
      fieldType: FieldType.MultiSelectChip,
      fieldLabel: 'Sondermodell',
      placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_MULTIPLE,
      inputType: '',
      mandatory: false,
      validationRegex: '',
      widthClass: WidthClass.W12,
      subProjectFlag: false,
      disable: false,
      multiple: true,
      visible: true,
      options: getSpecialModelListSEAT(),
    },
    {
      formTypeId: '1',
      formFieldName: 'drive',
      fieldType: FieldType.MultiSelectChip,
      fieldLabel: 'Antrieb',
      placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_MULTIPLE,
      inputType: '',
      mandatory: false,
      validationRegex: '',
      widthClass: WidthClass.W12,
      subProjectFlag: false,
      disable: false,
      multiple: true,
      visible: true,
      options: getDriveListSEAT(),
    },
    {
      formTypeId: '1',
      formFieldName: 'trim',
      fieldType: FieldType.MultiSelectChip,
      fieldLabel: 'Trim',
      placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_MULTIPLE,
      inputType: '',
      mandatory: false,
      validationRegex: '',
      widthClass: WidthClass.W12,
      subProjectFlag: false,
      disable: false,
      multiple: true,
      visible: true,
      options: getTrimListSEAT(),
    },
    {
      formTypeId: '1',
      formFieldName: 'assetType',
      fieldType: FieldType.Dropdown,
      fieldLabel: 'Medientyp',
      placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
      inputType: '',
      mandatory: false,
      validationRegex: '',
      widthClass: WidthClass.W12,
      subProjectFlag: false,
      disable: false,
      visible: true,
      options: AssetTypesImageVideo,
    },
    {
      formTypeId: '1',
      formFieldName: 'mediaType',
      fieldType: FieldType.MultiSelectChip,
      fieldLabel: 'Medienart',
      placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_MULTIPLE,
      inputType: '',
      mandatory: false,
      enableMatOptGroup: true,
      validationRegex: '',
      widthClass: WidthClass.W12,
      subProjectFlag: false,
      disable: false,
      multiple: true,
      visible: true,
      options: MEDIATYPE,
    },
    {
      formTypeId: '1',
      formFieldName: 'channels',
      fieldType: FieldType.MultiSelectChip,
      fieldLabel: 'Kanäle',
      placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_MULTIPLE,
      inputType: '',
      mandatory: false,
      validationRegex: '',
      widthClass: WidthClass.W12,
      subProjectFlag: false,
      disable: false,
      multiple: true,
      visible: true,
      options: CHANNELS,
    },
    {
      formTypeId: '4',
      formFieldName: 'status',
      fieldType: FieldType.Dropdown,
      fieldLabel: $localize`Status`,
      placeholder: $localize`:placeholder:-- All Status --`,
      inputType: '',
      mandatory: false,
      validationRegex: '',
      widthClass: WidthClass.WFull,
      subProjectFlag: false,
      disable: false,
      visible: true,
      options: [],
    },
    {
      formTypeId: '17',
      formFieldName: 'expiryDate_from',
      fieldType: FieldType.Date,
      fieldLabel: $localize`Expiry date: from`,
      placeholder: $localize`DD/MM/YYYY`,
      inputType: '',
      mandatory: false,
      validationRegex: '',
      widthClass: WidthClass.W12,
      disable: false,
      visible: true,
    },
    {
      formTypeId: '18',
      formFieldName: 'expiryDate_to',
      fieldType: FieldType.Date,
      fieldLabel: $localize`Expiry date: to`,
      placeholder: $localize`DD/MM/YYYY`,
      inputType: '',
      mandatory: false,
      validationRegex: '',
      widthClass: WidthClass.W12,
      disable: false,
      visible: true,
    },
  ],
};
